import * as ProtoGameServerBase from './gameserver/proto_gameserver_base';
import ModelBase from '../../../framework/core/mvvm/model_base';
import NetMsgDataGameServerBase from './gameserver/net_msg_data_map_gameserver';
import TimeManager from '../../../manager/time_manager';
import { NetClient, NetClientProtoType } from '../../../framework/net/net_client';
import { NetMsgDataMapHallNotify } from './hallnotify/net_msg_data_map_hall_notify';
import { ProtoHallServerNotify } from './hallnotify/proto_hall_gameserver_notify';
import LogManager from '../../../manager/log_manager';
// import SceneManager from '../../../manager/scene_manager';

const { ccclass } = cc._decorator;


declare interface ISubscribeData{

    propertyName? : string;
    mapData? : any[];
    ignoreModuleActive?: boolean;
}

export function subscribeMsg(msgData : any[],ignoreModuleActive : boolean = true){
    return function (target: any, propertyName: string, descriptor: PropertyDescriptor){  

        let data : ISubscribeData = {};
        data.mapData = msgData;
        data.propertyName = propertyName;
        data.ignoreModuleActive = ignoreModuleActive;

        target.subscribeMsgList = target.subscribeMsgList ? target.subscribeMsgList : [];
        target.subscribeMsgList.push(data);    
    }
}

@ccclass
export default class ServerBase extends cc.Component {

    model: ModelBase = new ModelBase()
    netClient: NetClient = new NetClient();
    _lastPingTime : number = null
    lastReceivePingTime : number = 0
    _pingDelayTime: number = 0
    clientName : string
    netClientProtoType : NetClientProtoType
    protected disconnectTimeOut  = 15000

    public subscribeMsgList : ISubscribeData[] ;
    
    private _isReconnect : boolean;
    public get isReconnect() : boolean {
        return this._isReconnect;
    }
    

    onNotifyPing: (ping:number) => void;

    onReconnected:()=>void;

    protected init(clientName) {
        this.model = new ModelBase();
        this.netClient = new NetClient();
        this.netClient.name = clientName;
        this.clientName = clientName;
        this.model.init(this.netClient)        
    }

    private _regiserMsg(){
        let self = this;
        if (this.subscribeMsgList) {
            this.subscribeMsgList.forEach(element => {       
                this.model.subscibeMsgEvent(element.mapData,function (propertyName,protoData){   
                    self[propertyName](protoData);
                }.bind(this,element.propertyName),element.ignoreModuleActive);
            });
        }
    }

    _onConnectState: (state: string) => void;

    state = null
    _reconTimes = 0
    _maxReconTimes = 100

    private url : string 


    //连接服务器
    protected connect(url, callback?: (state: string) => void) {
        this.close()
        this._onConnectState = callback
        this.url = url      
        this.netClient.connect(url, this.netClientProtoType ? this.netClientProtoType :NetClientProtoType.LuaGameServer);
        this.netClient.onConnectStateEvent = this._onConnectStateEvent.bind(this)
        this.unschedule(this.checkConnect)
        this.scheduleOnce(this.checkConnect, 30)
        let text = this.clientName + "服务器请求连接："+ url
        LogManager.instance.log(text, true)
    }

    checkConnect() {
        this.unschedule(this.checkConnect)
        this.reconnectServer()
        let text = this.clientName + "服务器连接超时，重连！"
        LogManager.instance.log(text, true)
    }

    close() {
        this.unschedule(this._reconnect)
        this.unschedule(this.checkConnect)
        this.unschedule(this._checkPing)
        this.unschedule(this._loginIsTimeOut);
        this.netClient.activeClose();
        this._isReconnect = false;
    }


    disconnect(){
        if(this.netClient){
            this.netClient.disconnect();
        }        
    }

    protected startCheckPing() {
        this.unschedule(this._loginIsTimeOut);
        this._reconTimes = 0
        this._lastPingTime = Date.now()
        this.lastReceivePingTime = this._lastPingTime
        this._requestPing()
        this.unschedule(this._checkPing)
        this.schedule(this._checkPing, 4, cc.macro.REPEAT_FOREVER)
    }


    private _checkPing() {
        let time = Date.now()
        // cc.log("checkPing", time)
        this._requestPing()
        if(this._lastPingTime == null){
            this._lastPingTime = Date.now()
        }

        if (time - this.lastReceivePingTime > this.disconnectTimeOut) {
            this.heartbeat_timeout_reconnect()
        }

        if(this.onNotifyPing){
            this.onNotifyPing(this._pingDelayTime)
        }
    }

    protected _requestPing() {
        if (this.netClient.netState) {
            let data: ProtoGameServerBase.Login.IPingReq = {
            }
            this.model.sendMsg(NetMsgDataGameServerBase.Ping, data);
        }
    }

    reconnectServer() {
        if (TimeManager.instance.backGround) {
            cc.warn("正在后台中，不重连！")
            return
        }
        let time = 1
        if (this._reconTimes >= 2) {
            time = 3
        }
        cc.log("断线重连！", time, this._reconTimes)
        
        this.unschedule(this._reconnect)
        this.unschedule(this.checkConnect)
        this.unschedule(this._checkPing)
        this.unschedule(this._loginIsTimeOut);
        this.scheduleOnce(this._reconnect, time)
    }

    protected onReconnectServer() {

    }

    protected onConnected() {

    }
    

    private _reconnect() {
        this._reconTimes = this._reconTimes + 1
        cc.log("~~~~_reconnect~~~~~~~~~~",this._reconTimes)
        if (this._reconTimes < this._maxReconTimes) {
            this.connect(this.url, this._onConnectState)
            this._isReconnect = true;    
            this.onReconnectServerSuccees();       
        } else {
            cc.warn(this.clientName, "断线重连次数用完提示登陆失败")
            this.close()
            this.onReconnectServerFail()
        }
    }

    protected onReconnectServerFail() {

    }

    protected onReconnectServerSuccees(){

        if (this.onReconnected) {
            this.onReconnected()
        }
    }

    _loginIsTimeOut() {
        cc.warn(this.clientName, "服务器连接超时！")
        this.reconnectServer()
    }




    _onConnectStateEvent(state) {
        this.unschedule(this.checkConnect)
        cc.warn(this.clientName, "onConnectStateEvent", state)
        if ("OPEN" == state) {
            this._reconTimes = 0
            this.subscibeMsgEvent()
            this.scheduleOnce(this._loginIsTimeOut, 10);
            this.onConnected();                        
        } else if (state == 'error') {
            this.reconnectServer()
        } else if ("CLOSE" == state) {
            cc.warn("连接中断，自动重连！")
            this.reconnectServer()
        } else if (state == "TIMEOUT") {//连接超时
            this.reconnectServer()
        }
        if (this._onConnectState != null) {
            this._onConnectState(state)
        }

        
    }

    private subscibeMsgEvent() {
        let self = this
        this.model.clearMsgEvent()
        this.netClient.clearMsgEvent()

        //必须要登录成功后才能使用ping
        self.model.subscibeMsgEvent<ProtoGameServerBase.Login.IPingRsp>(NetMsgDataGameServerBase.Ping, function () {
           self.updatePing();
        }, true)           

        self.model.subscibeMsgEvent<ProtoHallServerNotify.IPingRsp>(NetMsgDataMapHallNotify.Ping, function () {
            self.updatePing();
        }, true)    

        this._regiserMsg();
    }

    protected updatePing(){
     
        this.lastReceivePingTime = Date.now()
        if(this._lastPingTime){
            this._pingDelayTime = this.lastReceivePingTime - this._lastPingTime
            this._lastPingTime = null
            if(this._pingDelayTime == 0){
                this._pingDelayTime = 0.06
            }
            if(this.onNotifyPing){
                this.onNotifyPing(this._pingDelayTime)
            }
        }
    }


    heartbeat_timeout_reconnect(){
        cc.warn(this.clientName, "heartbeat_timeout_reconnect")
        let self = this
        self.close()
        self.scheduleOnce(function(){
            self.reconnectServer()
        }, 0.2)        
    }

    exit() {
        this.onNotifyPing = null
    }

}
